import { configureStore } from '@reduxjs/toolkit';
import singUpReducer from './reducer/signUpSlice';
import accountReducer from './reducer/accountSlice';
import initialOfferingReducer from './reducer/initialOfferingSlice';
import filtersDataReducer from './reducer/filtersSlice';
import secondaryOfferingReducer from './reducer/secondaryOfferingSlice';
import accountActivationReducer from './reducer/accountActivationSlice';
import secondaryQuickBuyReducer from './reducer/secondaryQuickBuySlice';
import notifyMeSliceReducer from './reducer/notifyMeSlice';
import portfolioOpenOrderReducer from './reducer/portfolioOpenOrderSlice';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import { combineReducers } from 'redux';
import propertyDetailsReducer from './reducer/propertyDetailSlice';
import faqs from './reducer/faqSlice';
import tradeDetailsReducer from './reducer/tradeDetailsSlice';
import favorite from './reducer/favoriteSlice';
import legalSlice from './reducer/legalSlice';
import portfolioReducer from './reducer/portfolioSlice';
import accountStatementSlice from './reducer/accountStatementSlice';
import ownedAssetDetailsReducer from './reducer/ownedAssetDetails';
import dwollaAgreementsReducer from './reducer/onbordingSlice';

export const rootReducer = combineReducers({
  authUser: singUpReducer,
  userData: accountReducer,
  initialOffering: initialOfferingReducer,
  filters: filtersDataReducer,
  secondaryOffering: secondaryOfferingReducer,
  propertyDetails: propertyDetailsReducer,
  notifyMeSlice: notifyMeSliceReducer,
  tradeDetails: tradeDetailsReducer,
  accountActivation: accountActivationReducer,
  faqs: faqs,
  favorites: favorite,
  secondaryPlaceBid: secondaryQuickBuyReducer,
  portfolioOpenOrder: portfolioOpenOrderReducer,
  portfolio: portfolioReducer,
  legal: legalSlice,
  accountStatements: accountStatementSlice,
  ownedAssetDetails: ownedAssetDetailsReducer,
  dwollaAgreement: dwollaAgreementsReducer
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['authUser', 'userData'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk],
});

export const persistor = persistStore(store);
